export default __webpack_public_path__ + "static/media/timer_background_s2.3582c08e.jpg";